import { initializeApp } from 'firebase/app';
import { getStorage } from 'firebase/storage';

const resumeFirebaseConfig = {
    apiKey: "AIzaSyAJLjmGyvJDCHVjaLnwmBN0lJkBmKrmRjw",
    authDomain: "data-fb655.firebaseapp.com",
    projectId: "data-fb655",
    storageBucket: "data-fb655.appspot.com",
    messagingSenderId: "830335965273",
    appId: "1:830335965273:web:d5fe27f31423a2ab85b948",
    measurementId: "G-TZPN1MYVKB"
};

const resumeApp = initializeApp(resumeFirebaseConfig, 'resumeApp');
export const resumeStorage = getStorage(resumeApp);